<template>
  <div class="wallet-page">
    <ul class="breadcrumb">
      <li>
        <router-link :to="{name: 'Home'}"><i class="el-icon-s-home"></i>Home</router-link>
      </li>
      <li>
        <router-link :to="{name: 'Dashboard'}"><i class="el-icon-s-grid"></i>Dashboard</router-link>
      </li>
      <li>
        <span>Buy Mining</span>
      </li>
    </ul>
    <div class="buy-package-wrap" :class="{ 'loading': isProcessing }">
      <h4 class="title">Buy Mining</h4>
      <div class="flex-box">
        <div class="quick-buy">
          <div class="field">
            <div class="field-label">Quick buy(USDT)</div>
            <div class="items">
              <div class="item" v-for="(item, index) in quickBuyList" :key="index"  @click="quickBuy(item.amount)">
                <div class="item-head">
                  <img src="/assets/images/icons/usdt.png" alt="">${{item.amount}}
                </div>
                <div class="item-body">
                  <p>{{item.amountPPST}} PPST</p>
                  <p>{{item.amountPPST / 5}} PPS</p>
                  <p>Bonus: {{item.bonusPPST}}%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form class="fields">
          <div class="field">
            <div class="field-label">Buy Amount (USDT)</div>
            <div class="field-input">
              <el-input placholder="Amount" v-model="form.amount"></el-input>
            </div>
            <div class="field-tip">
              <ul>
                <li><em>Discount Amount: </em><strong>1 PPST = 1 USDT</strong></li>
                <li><em>Minimum investment: </em><strong>100 PPST</strong></li>
                <li><strong>1 PPS = 5 PPST</strong></li>
              </ul>
            </div>
          </div>
          <div class="field">
            <div class="field-label">PPS/PPST</div>
            <div class="field-input">
              <el-input placholder="PPST Amount" disabled v-model="estimateForm.ppst"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Bonus PPST</div>
            <div class="field-input">
              <el-input placholder="PPST Amount" disabled v-model="estimateForm.bonusPpst"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Bonus Iron</div>
            <div class="field-input">
              <el-input placholder="Iron Amount" disabled  v-model="estimateForm.bonusIron"></el-input>
            </div>
          </div>
          <div class="field">
            <button class="el-button el-button--default" :class="{ 'disabled': !isValidated }" type="button" @click="buyIeo"><span>Purchase</span></button>
          </div>
          <div class="field node-info-wrapper">
            <a class="node-info" href="https://www.aleo123.io/address/aleo177zvr6mx6tsrwmhxjh03clvg8nu604z9dh853v4szg2t2x3fygyss4f8p6" target="_blank">
              <span>ALEO Mining RRG Node 1</span>
              <img src="/assets/images/nodes/aleo123.png" alt="ALEO Mining RRG Node 1">
            </a>
          </div>
          <div class="field node-info-wrapper">
            <a class="node-info" href="https://www.damominer.hk/miner/aleo177zvr6mx6tsrwmhxjh03clvg8nu604z9dh853v4szg2t2x3fygyss4f8p6" target="_blank">
              <span>ALEO Mining RRG Node 2</span>
              <img src="/assets/images/nodes/damo-miner.png" alt="ALEO Mining RRG Node 2">
            </a>
          </div>
        </form>
      </div>
      <div class="field">
        <div class="field-tip">
          <p><i class="el-icon-info"></i><em>We implement PPST bonus policy for buyers as follows:</em></p>
          <ul>
            <li>Investment <strong>&lt; $200</strong>: No bonus</li>
            <li>Investment <strong>&ge; $200</strong>: Bonus 5%</li>
            <li>Investment <strong>&ge; $3000</strong>: Bonus 10%</li>
          </ul>
        </div>
        <div class="field-tip">
          <p><img src="/assets/images/icons/promotion.png" alt="Promotion"><strong>Promotion: </strong><em>From May 20, 2023, you will receive Iron token rewards for your investment packages. Note, this program may end soon when the amount of Iron tokens is exhausted.</em></p>
          <ul>
            <li>1000$ get <strong>12.5 Iron/90days</strong> (&asymp; 0.13888 IRON/day)</li>
            <li>3000$ get <strong>45 Iron/90days</strong> (&asymp; 0.5 IRON/day)</li>
            <li>5000$ get <strong>87.5 Iron/90days</strong> (&asymp; 0.972 IRON/day)</li>
            <li>10000$ get <strong>200 Iron/90days</strong> (&asymp; 2.222 IRON/day)</li>
            <li>20000$ get <strong>450 Iron/90days</strong> (&asymp; 5.0 IRON/day)</li>
            <li>50000$ get <strong>1125 Iron/90days</strong> (&asymp; 12.5 IRON/day)</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="history-section">
      <div class="table-box">
        <h4 class="title">History</h4>
        <div class="table-fixed-wrap">
          <div class="table-box-inner">
            <dl class="table-medium">
              <dt>
                <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                <div class="width-1_5x">{{ $t('TEXT_AMOUNT_USD') }}</div>
                <div class="width-1_5x">{{ $t('TEXT_AMOUNT_PPST') }}</div>
                <div class="width-1_5x">{{ $t('TEXT_BONUS_AMOUNT_IRON') }}</div>
                <div class="width-1_5x">{{ $t('TEXT_BONUS_AMOUNT_PPST') }}</div>
                <div>{{ $t('TEXT_PRICE') }}</div>
                <div class="flex-1">{{ $t('TEXT_DATE') }}</div>
              </dt>
              <dd v-for="(pack, index) in transactionHistory" :key="pack.id">
                <div class="item-no">{{ index + 1 }}</div>
                <div class="width-1_5x">{{ pack.beautyAmountUsd }}</div>
                <div class="width-1_5x">{{ pack.beautyAmountPps }}</div>
                <div class="width-1_5x">{{ pack.beautyBonusIron }}</div>
                <div class="width-1_5x">{{ pack.beautyBonusPps }}</div>
                <div>{{ pack.price }}</div>
                <div class="flex-1">{{ pack.beautyCreatedAt }}</div>
              </dd>
              <dd v-if="!pagination.totalPage" class="no-data-wrap">
                <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
              </dd>
            </dl>
            <el-pagination
              v-if="pagination.totalPage"
              :current-page="pagination.currentPage"
              :page-count="pagination.totalPage"
              background
              layout="prev, pager, next"
              @current-change="goToPage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UtilService from '@/utils/UtilService'
import BigNumber from 'bignumber.js'
import _ from 'lodash'
export default {
  data () {
    return {
      isProcessing: false,
      form: {
        amount: ''
      },
      estimateForm: {
        ppst: 0,
        pps: 0,
        bonusPpst: 0,
        bonusPps: 0,
        bonusIron: 0
      },
      quickBuyList: [
        {
          amount: 100,
          amountPPST: 100,
          bonusPPST: 0
        },
        {
          amount: 200,
          amountPPST: 200,
          bonusPPST: 5
        },
        {
          amount: 300,
          amountPPST: 300,
          bonusPPST: 5
        },
        {
          amount: 500,
          amountPPST: 500,
          bonusPPST: 5
        },
        {
          amount: 1000,
          amountPPST: 1000,
          bonusPPST: 5
        },
        {
          amount: 2000,
          amountPPST: 2000,
          bonusPPST: 5
        },
        {
          amount: 3000,
          amountPPST: 3000,
          bonusPPST: 10
        },
        {
          amount: 5000,
          amountPPST: 5000,
          bonusPPST: 10
        },
        {
          amount: 10000,
          amountPPST: 10000,
          bonusPPST: 10
        },
        {
          amount: 20000,
          amountPPST: 20000,
          bonusPPST: 10
        },
        {
          amount: 50000,
          amountPPST: 50000,
          bonusPPST: 10
        },
        {
          amount: 100000,
          amountPPST: 100000,
          bonusPPST: 10
        }
      ],
      isLoadingHistory: false
    }
  },
  computed: {
    isValidated () {
      return this.form.amount && !isNaN(this.form.amount) && parseFloat(this.form.amount) > 0 &&
        this.userConfig.is_allow_buy &&
        UtilService.isInteger(this.form.amount) &&
        new BigNumber(this.form.amount).comparedTo(this.userConfig.min_buy) !== -1 &&
        new BigNumber(this.form.amount).comparedTo(this.userConfig.max_buy) !== 1
    },
    isBalanceNotEnough () {
      return this.form.amount &&
        (new BigNumber(this.form.amount).comparedTo(this.maxAmountUsd) === 1 ||
        new BigNumber(this.form.amount).comparedTo(this.selectedBalance.balanceUsdt) === 1)
    },
    isBalanceIsNotValid () {
      return this.form.amount &&
        (isNaN(this.form.amount) || new BigNumber(this.form.amount).comparedTo(this.minAmountUsd) !== 1)
    },
    transactionHistory () {
      return this.$store.getters.transactionHistory
    },
    pagination () {
      return this.$store.getters.pagination
    },
    userConfig () {
      return this.$store.getters.userConfig
    },
    user () {
      return this.$store.getters.user
    }
  },
  watch: {
    'form.amount': _.debounce(function () {
      this.getEstimateBuy()
    }, 600)
  },
  created () {
    this.fetch()
  },
  methods: {
    async getEstimateBuy () {
      const res = await this.$store.dispatch('getEstimateBuy', this.form.amount)
      res.status && (this.estimateForm = res.data)
    },
    quickBuy (amount) {
      this.form.amount = amount
      this.buyIeo()
    },
    async buyIeo () {
      if (!this.isValidated) return
      await this.getEstimateBuy()
      const textConfirm = `<h4>Final Commitment Agreement between Company and Customer</h4>
        <div class="notification-buy-content">
          <p>The company RRG Mining LTD and the customer <strong>${this.user.username}</strong> hereby confirm and commit to the following:</p>
          <ol>
            <li>
              ALEO's Mining hashrate rental service:
              <ul>
                <li>Hashrate package: <strong>${this.estimateForm.pps}PPS/ ${this.estimateForm.ppst}PPST</strong>.</li>
                <li>Mining Output: <strong>50% tokens</strong></li>
                <li>Payment period: <strong>1100 days</strong> from</li>
                <li>The Aleo's first mainnet day or the 10th days since purchase time</li>
              </ul>
            </li>
            <li>
              Price
              <ul>
                <li>Price of the package is: <strong>$${this.form.amount}</strong></li>
              </ul>
            </li>
            <li>
              Customer's Commitment:
              <ul>
                <li>The customer agrees to voluntarily purchase the Aleo's mining hashrate rental service from RRG Mining, without any coercion</li>
                <li>The service package is non-cancellable and non-refundable.</li>
              </ul>
            </li>
          </ol>
          <br>
          <p>By clicking the <strong>"Confirm"</strong> button, you acknowledge and confirm the terms and commitments stated above.</p>
        </div>
        `
      const body = {
        amount: this.form.amount
      }
      this.$confirm(textConfirm, this.$t('TEXT_CONFIRM'), {
        confirmButtonText: 'Confirm',
        dangerouslyUseHTMLString: true,
        iconClass: 'no-icon',
        customClass: 'buy-confirm',
        cancelButtonText: this.$t('BTN_CANCEL'),
        type: 'warning'
      }).then(() => {
        this.isProcessing = true
        this.$store.dispatch('buyPackage', body).then(rs => {
          this.isProcessing = false
          if (rs) {
            this.getHistory()
            this.form.amount = ''
          }
        })
      }).catch(() => {
      })
    },
    min () {
      console.log(this.userConfig)
      this.form.amount = this.userConfig.min_buy
    },
    max () {
      this.form.amount = this.userConfig.max_buy
    },
    fetch () {
      console.log(this.pagination.page)
      this.$store.dispatch('getTransHistory', this.pagination.page)
    },
    goToPage (page) {
      const temp = JSON.parse(JSON.stringify(this.pagination))
      temp.page = page
      this.$store.dispatch('setPagination', temp)
      this.fetch()
    }
  }
}
</script>
